import { useEffect, useRef, useState } from 'react';

/**
 *
 * A hook for temporarily preventing scroll on the document body.
 * Useful when e.g showing a modal.
 *
 */
const usePreventBodyScroll = (initialPrevented = false) => {
  const [scrollPrevented, setScrollPrevented] = useState(initialPrevented);
  const scrollY = useRef<number | null>(null);
  const unLockedPosition = useRef<string | null>(null);

  const lock = () => {
    scrollY.current = window.scrollY;
    unLockedPosition.current = document.body.style.position;
    document.body.style.position = 'fixed';
  };

  const unlock = () => {
    document.body.style.position = unLockedPosition.current as string;
    window.scrollTo(0, scrollY.current as number);
    scrollY.current = null;
  };

  useEffect(() => {
    if (scrollPrevented) {
      lock();
    } else if (scrollY.current != null) {
      unlock();
    }

    return () => {
      if (scrollPrevented) {
        unlock();
      }
    };
  }, [scrollPrevented, scrollY]);

  return [scrollPrevented, setScrollPrevented] as const;
};

export default usePreventBodyScroll;
